<template>
  <div>
    <card shadow>
      <div class="pt-4 text-center">
        <h3 class="h3 title">
          <span class="d-block">Owner Tools</span>
        </h3>
        <button
          type="button"
          class="mt-3 btn btn-warning btn-block"
          data-toggle="modal"
          data-target="#badgeCreate"
        >Create Badge</button>
        <a
          role="button"
          class="mt-3 btn btn-block text-white"
          style="background-color: #6320FF;"
          href="https://my.openphone.co/inbox/CNDRgnL6UB"
          target="_blank"
        >OpenPhone Messaging</a>
      </div>
    </card>

    <modal id="badgeCreate" title="Badge Create">
      <badge-create-form />
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/Modal.vue";
import BadgeCreateForm from "@/views/dashboard/components/BadgeCreateForm.vue";

export default {
  name: "ownertoolscard",
  props: {
    displayName: String,
    userTitle: String
  },
  components: {
    "badge-create-form": BadgeCreateForm,
    modal: Modal
  }
};
</script>

<style scoped>
</style>
